module.exports = __webpack_public_path__ + "static/media/blog-banner.a36465a2.jpg";